"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.callResolveVariable = exports.resolveVariableWithMultipleWorkerThreads = void 0;
const worker_thread_1 = require("@sundaysky/worker-thread");
const logic_1 = require("./logic");
/**
 * This is the function that the main thread will call.
 *
 * @param args array of array of arguments to pass to the function the worker thread runs
 * @param workers
 */
const resolveVariableWithMultipleWorkerThreads = (args, workers) => __awaiter(void 0, void 0, void 0, function* () {
    const funcName = "callResolveVariable";
    const workerData = { filePath: __filename, funcName, args };
    const multiWorkerResult = yield (0, worker_thread_1.runWithMultipleWorkerThread)(workerData, workers);
    return multiWorkerResult.results;
});
exports.resolveVariableWithMultipleWorkerThreads = resolveVariableWithMultipleWorkerThreads;
/**
 * This is the function that the worker thread will call.
 *
 * @param variableDefinition
 * @param context
 */
const callResolveVariable = (variableDefinition, context) => {
    return (0, logic_1.resolveVar)(variableDefinition, context);
};
exports.callResolveVariable = callResolveVariable;
//# sourceMappingURL=resolveVariableWithWorkerThread.js.map